const pagesDeviceProfileMdmEn = {
  emptyState: {
    action: 'Add integration',
    description: 'Connect your MDM software (Intune or LANSCOPE) to view device management information here.',
    title: 'No MDM software integrated.'
  },
  mock: {
    item: {
      activationLock: 'Activation Lock',
      activationLockEnabled: 'Activation Lock Enabled',
      administratorName: 'Administrator Name',
      amount: 'Amount',
      androidId: 'Android ID',
      antiSpywareStatus: 'Anti-Spyware Status',
      antiVirusStatus: 'Anti-Virus Status',
      antivirusStatus: 'Antivirus Status',
      apnUserName: 'APN User Name',
      appleCareId: 'AppleCare ID',
      appleId: 'Apple ID',
      assetNumber: 'Asset Number',
      assetTag: 'Asset Tag',
      availableDeviceCapacity: 'Available Device Capacity',
      availableRamMemory: 'Available RAM Memory',
      batteryHealth: 'Battery Health',
      batteryLevel: 'Battery Level',
      batteryRemaining: 'Battery Remaining',
      batteryStatus: 'Battery Status',
      batteryTemperature: 'Battery Temperature',
      batteryVoltage: 'Battery Voltage',
      biosManufacturer: 'BIOS Manufacturer',
      biosVersion: 'BIOS Version',
      blockLevelEncryptionCapable: 'Block-Level Encryption Capable',
      bluetoothMacAddress: 'Bluetooth MAC Address',
      bootDriveFreeCapacity: 'Boot Drive Free Capacity',
      carrier: 'Carrier',
      clientInstallStatus: 'Client Install Status',
      clientInstalledAt: 'Client Installed At',
      clientLastActiveAt: 'Client Last Active At',
      clientType: 'Client Type',
      clientUninstalledAt: 'Client Uninstalled At',
      cloudBackupEnabled: 'Cloud Backup Enabled',
      computerName: 'Computer Name',
      coreCount: 'Core Count',
      cpuCoreCount: 'CPU Core Count',
      cpuMaxFrequency: 'CPU Max Frequency',
      cpuName: 'CPU Name',
      currentCarrierNetwork: 'Current Carrier Network',
      currentCarrierNetwork2: 'Current Carrier Network 2',
      customField: 'Custom Field {{number}}',
      dataCollectedAt: 'Data Collected At',
      dataProtection: 'Data Protection',
      dealer: 'Dealer',
      depAssetTag: 'DEP Asset Tag',
      depEnroller: 'DEP Enroller',
      designCapacity: 'Design Capacity',
      deviceCapacity: 'Device Capacity',
      deviceEnrollmentStatus: 'Device Enrollment Status',
      deviceLocatorEnabled: 'Device Locator Enabled',
      deviceLocatorService: 'Device Locator Service',
      deviceName: 'Device Name',
      deviceOwnershipType: 'Device Ownership Type',
      deviceRooted: 'Device Rooted',
      deviceType: 'Device Type',
      diskEncryption: 'Disk Encryption',
      dndEnabled: 'Do Not Disturb Enabled',
      eid: 'EID',
      email: 'Email',
      encryptionStatus: 'Encryption Status',
      enrolledAt: 'Enrolled At',
      enrollmentCompletedAt: 'Enrollment Completed At',
      enrollmentMethod: 'Enrollment Method',
      ethernetMacAddress: 'Ethernet MAC Address',
      fileLevelEncryptionCapable: 'File-Level Encryption Capable',
      fileVault2Enabled: 'FileVault 2 Enabled',
      fileVault2Status: 'FileVault 2 Status',
      firewallEnabled: 'Firewall Enabled',
      firewallStatus: 'Firewall Status',
      firstEnrolledAt: 'First Enrolled At',
      freeStorageCapacity: 'Free Storage Capacity',
      fullChargeCapacity: 'Full Charge Capacity',
      hardwareEncryption: 'Hardware Encryption',
      hostName: 'Host Name',
      iccid: 'ICCID',
      iccid2: 'ICCID2',
      imei: 'IMEI',
      imei2: 'IMEI2',
      imsi: 'IMSI',
      internalStorageCapacity: 'Internal Storage Capacity',
      introductionDate: 'Introduction Date',
      introductionType: 'Introduction Type',
      iosNativeAppEnrollment: 'iOS Native App Enrollment',
      ipAddress: 'IP Address',
      itunesAccountEnabled: 'iTunes Account Enabled',
      jailbreakDetected: 'Jailbreak Detected',
      jailbreakStatus: 'Jailbreak Status',
      lastBackupAt: 'Last Backup At',
      lastCheckIn: 'Last Check-in',
      lastCloudBackupAt: 'Last Cloud Backup At',
      lastContactAt: 'Last Contact At',
      lastEnrolledAt: 'Last Enrolled At',
      lastICloudBackupAt: 'Last iCloud Backup At',
      lastInventoryUpdatedAt: 'Last Inventory Updated At',
      lastSyncedAt: 'Last Synced At',
      lease: 'Lease',
      leaseDepreciationDeadline: 'Deadline (Lease/Depreciation)',
      leaseEndDate: 'Lease End Date',
      leaseExpiration: 'Lease Expiration',
      leaseStartDate: 'Lease Start Date',
      linkedApp: 'Linked App',
      localIpAddress: 'Local IP Address',
      location: 'Location',
      loginUserDisplayName: 'Login User Display Name',
      loginUserName: 'Login User Name',
      lostModeEnabled: 'Lost Mode Enabled',
      lostModeStatus: 'Lost Mode Status',
      macAddress: 'MAC Address',
      macosFileVault: 'macOS FileVault',
      macosSip: 'macOS System Integrity Protection',
      maker: 'Maker',
      managed: 'Managed',
      managedDeviceName: 'Managed Device Name',
      managementGroupCode: 'Management Group Code',
      managementGroupName: 'Management Group Name',
      managementId: 'Management ID',
      managementInfoUpdatedAt: 'Management Info Updated At',
      manufacturer: 'Manufacturer',
      manufacturerMaker: 'Manufacturer',
      maxFrequency: 'Max Frequency',
      mdmProfileExpiration: 'MDM Profile Expiration',
      meid: 'MEID',
      memoryCapacity: 'Memory Capacity',
      model: 'Model',
      modelIdentifier: 'Model Identifier',
      modelName: 'Model Name',
      modelNo: 'Model Number',
      modelNumber: 'Model Number',
      netbiosName: 'NetBIOS Name',
      operatorCode: 'User Code',
      operatorName: 'User Name',
      operatorType: 'User Type',
      orderDate: 'Order Date',
      orderNumber: 'Order Number',
      osArchitecture: 'OS Architecture',
      osBuildNumber: 'OS Build Number',
      osBuildVersion: 'OS Build Version',
      osName: 'OS Name',
      osPlatform: 'OS Platform',
      osSupplementalBuild: 'OS Supplemental Build',
      osType: 'OS Type',
      osVersion: 'OS Version',
      ownership: 'Ownership',
      passcodeCompliance: 'Passcode Compliance',
      passcodeCompliant: 'Passcode Compliant',
      passcodeCompliantProfile: 'Passcode Compliant Profile',
      passcodeExists: 'Passcode Exists',
      passcodePolicyCompliant: 'Passcode Policy Compliant',
      passcodeSet: 'Passcode Set',
      passcodeSetting: 'Passcode Setting',
      passcodeStrength: 'Passcode Strength',
      peripheralRegisteredAt: 'Peripheral Registered At',
      phoneNumber: 'Phone Number',
      phoneNumber2: 'Phone Number 2',
      platform: 'Platform',
      processorArchitecture: 'Processor Architecture',
      processorCount: 'Processor Count',
      processorSpeedMhz: 'Processor Speed (MHz)',
      processorType: 'Processor Type',
      productName: 'Product Name',
      profilePasscodeCompliant: 'Profile Passcode Compliant',
      purchaseDate: 'Purchase Date',
      purchaseOrderNumber: 'Purchase Order Number',
      purchasePrice: 'Purchase Price',
      purchaseType: 'Purchase Type',
      purchased: 'Purchased',
      purchasedAt: 'Purchased At',
      purchaser: 'Purchaser',
      ramCapacity: 'RAM Capacity',
      rapidSecurityResponse: 'Rapid Security Response',
      roaming: 'Roaming',
      roaming2: 'Roaming 2',
      rootStatus: 'Root Status',
      serialNumber: 'Serial Number',
      servicePack: 'Service Pack',
      sipStatus: 'SIP Status',
      status: 'Status',
      storageCapacity: 'Storage Capacity',
      storageEncryption: 'Storage Encryption',
      storageFreeCapacity: 'Storage Free Capacity',
      storageUsageRate: 'Storage Usage Rate',
      subscriberCarrierNetwork: 'Subscriber Carrier Network',
      subscriberCarrierNetwork2: 'Subscriber Carrier Network 2',
      supervisedMode: 'Supervised Mode',
      supervisionStatus: 'Supervision Status',
      totalRamMemory: 'Total RAM Memory',
      totalStorageCapacity: 'Total Storage Capacity',
      udid: 'UDID',
      usageGroupName: 'Usage Group Name',
      usedDeviceCapacity: 'Used Device Capacity',
      usefulLife: 'Useful Life',
      userEmail: 'User Email',
      userName: 'User Name',
      vendor: 'Vendor',
      warranty: 'Warranty',
      warrantyEndDate: 'Warranty End Date',
      warrantyExpiration: 'Warranty Expiration',
      warrantyExpirationAt: 'Warranty Expiration Date',
      wifiMacAddress: 'Wi-Fi MAC Address',
      wifiMacAddressDashed: 'Wi-Fi MAC Address',
      wifiSsid: 'Wi-Fi SSID',
      windowsAcPowerStatus: 'Windows AC Power Status',
      windowsBatteryLevel: 'Windows Battery Level',
      windowsBatteryRemainingTime: 'Windows Battery Remaining Time'
    },
    section: {
      assetManagement: 'Asset Management',
      customFields: 'Custom Fields',
      hardwareInformation: 'Hardware Information',
      linkedApplications: 'Linked Applications',
      networkInformation: 'Network Information',
      osInformation: 'OS Information',
      securityStatus: 'Security Status'
    }
  }
};
export default pagesDeviceProfileMdmEn;